"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

class LottieAnimation extends _react.Component {
  /** Creates the lottie element */
  componentDidMount() {
    const {
      data
    } = this.props;

    _lottieWeb.default.loadAnimation({
      container: this.lottieAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: data
    });
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('lottie-animation', this.props.className),
      ref: c => {
        this.lottieAnimation = c;
      }
    });
  }

}

(0, _defineProperty2.default)(LottieAnimation, "propTypes", {
  className: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  data: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(LottieAnimation, "defaultProps", {
  className: ''
});
var _default = LottieAnimation;
exports.default = _default;